import { Button } from "components/UI/atoms";
import "./index.scss";

export const ActionCard = ({
  imageDesktop,
  imageMobile,
  title,
  description,
  cta,
  linkTo,
  customClassName = ""
}) => {
  return (
    <a className={`action-card ${customClassName}`} href={linkTo}>
      <picture>
        <source srcSet={imageDesktop} media="(min-width: 1150px)" />
        <source srcSet={imageMobile} />
        <img alt={cta} />
      </picture>
      <div className="action-card-details">
        <h3>{title}</h3>
        <p>{description}</p>
        <Button customClassName="action-card-button" size="small">
          {cta}
        </Button>
      </div>
    </a>
  );
};
